import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import styles from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewEdgeStates.module.scss"
import TableViewLoadingState, {
    GRAPHIC_ROWS_COUNT,
} from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewLoadingState/TableViewLoadingState"

import { CLEAR_SEARCH_EVENT } from "@constants/events"

import { TableViewNoResultsStateProps } from "./TableViewNoResultsState.types"

export default function TableViewNoResultsState(props: TableViewNoResultsStateProps) {
    const { children } = props

    const { tabContentName } = useObjectsView()

    // e.g. "All Open Credit Notes" -> "open credit notes".
    const listName = tabContentName.toLowerCase().replace("all", "").replace("&", "or").trim()

    return (
        <>
            {children}
            <div className={styles.base}>
                <TableViewLoadingState isAnimated={false} isBackground={true} numberOfRows={GRAPHIC_ROWS_COUNT} />
                <EmptyState
                    variant="default"
                    icon={faIcon({ name: "ban", style: "solid" })}
                    title="No results found..."
                    supportText={`There are no ${listName} matching the search`}
                    primaryCTA={{
                        children: "Clear search",
                        leftIcon: faIcon({ name: "xmark", style: "regular" }),
                        onClick: () => window.dispatchEvent(new CustomEvent(CLEAR_SEARCH_EVENT, {})),
                        noDebounce: true,
                    }}
                />
            </div>
        </>
    )
}
